import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import AdvertForm from './AdvertForm';

const AdminPanel = () => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const [posts, setPosts] = useState([]);
  const [showPosts, setShowPosts] = useState(false);

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  const fetchPosts = async () => {
    try {
      const response = await fetch('https://dropquote.co.za/backend/get_adverts.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const rawText = await response.text();
      console.log('Raw get_adverts response:', rawText);

      const result = JSON.parse(rawText);
      if (result.success) {
        console.log('Fetched posts:', result.data);
        setPosts(result.data);
        setShowPosts(true);
      } else {
        alert(result.message || 'Failed to fetch posts');
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
      alert('Error fetching posts: ' + error.message);
    }
  };

  const handleReply = async (applicationId, status, details) => {
    console.log('handleReply called with:', { applicationId, status, details }); // Debug
    try {
      const response = await fetch('https://dropquote.co.za/backend/reply_application.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          application_id: applicationId,
          status: status, // 'accepted' or 'rejected'
          ...details, // reason (for rejection) or contact_name, contact_phone, etc. (for acceptance)
        }),
      });

      const rawText = await response.text();
      console.log('Raw reply response:', rawText);

      const result = JSON.parse(rawText);
      if (result.success) {
        alert(`Application ${status} successfully!`);
      } else {
        alert(result.message || `Failed to ${status} application`);
      }
    } catch (error) {
      console.error(`Error ${status} application:`, error);
      alert(`Error ${status} application: ${error.message}`);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    window.location.href = '/';
  };

  console.log('showPosts:', showPosts);

  return (
    <div className="admin-panel">
      <AdvertForm
        fetchPosts={fetchPosts}
        posts={posts}
        showPosts={showPosts}
        setShowPosts={setShowPosts}
        onLogout={handleLogout}
        onReply={handleReply}
      />
    </div>
  );
};

export default AdminPanel;